import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { ApiUrl } from './apiUrl';

@Injectable({ providedIn: 'root' })
export class PosTerminalsService {
  constructor(private api: ApiService) {}

  getTerminals(storeId: string): Observable<any> {
    return this.api.getRequest(ApiUrl.getPosTerminals(storeId));
  }

  getTerminalUsers(storeId: string): Observable<any> {
    return this.api.getRequest(ApiUrl.getPosTerminalUsers(storeId));
  }

  createTerminal(storeId: string, data: any): Observable<any> {
    return this.api.postRequest(ApiUrl.createPosTerminal(storeId), data);
  }

  updateTerminal(storeId: string, terminalId: string, data: any): Observable<any> {
    return this.api.putRequest(ApiUrl.updatePosTerminal(storeId, terminalId), data);
  }

  deleteTerminal(storeId: string, terminalId: string): Observable<any> {
    return this.api.deletRequest(ApiUrl.deletePosTerminal(storeId, terminalId));
  }
}
